import { Injectable, inject } from '@angular/core';
import { AppStateService } from 'src/app/core/services/app-state.service';

import { StorageKeys } from 'src/app/configs/storage-keys-config';
import { AppConfigService } from '../config.service';
import { ConsoleService } from '../console.service';

@Injectable({
  providedIn: 'root',
})
export class GetApiUrlInitializerService {
  appConfigService = inject(AppConfigService);
  appStateService = inject(AppStateService);

  /* eslint-disable */
  public init(): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      const config = await this.appConfigService.getConfig();
      const domain: string = config.origin || window.location.origin;
      fetch(domain, { headers: { 'Cache-Control': 'no-cache' } })
        .then(async (res: any) => {
          for (const header of res.headers.entries()) {
            //get current dateTime from server response header
            if (header[0] == 'x-date')
              AppStateService.serverDateTime = header[1];

            //get api address form server response header
            if (header[0] == 'x-api-address') config.apiUrl = header[1];

            if (header[0] == 'x-language') {
              if ((header[1] as string)?.toLowerCase()?.includes('fa')) {
                localStorage.setItem(StorageKeys.lang, 'fa');
                localStorage.setItem(StorageKeys.dir, 'rtl');
                this.appStateService.currentAppLang.set('fa');
              } else {
                localStorage.setItem(StorageKeys.lang, header[1]);
                localStorage.setItem(StorageKeys.dir, 'ltr');
                this.appStateService.currentAppLang.set(header[1]);
              }
            } else {
              const storedLang =
                localStorage.getItem(StorageKeys.lang) ||
                sessionStorage.getItem(StorageKeys.lang);
              if (storedLang == 'fa' || storedLang == 'en-US')
                this.appStateService.currentAppLang.set(storedLang || 'fa');
            }
          }

          //agar server datetime nadad az local begir
          if (!AppStateService.serverDateTime)
            AppStateService.serverDateTime = new Date().toString();

          resolve(true);
        })
        .catch((error) => {
          ConsoleService.error('error ________', error);
          reject(false);
        });
    });
  }
  /* eslint-enable */
}
